import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.errorBridges.length > 0 ? _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, {
    staticClass: "ma-0 pa-0",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "ml-0 pl-0 pb-0 mb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c(VCardTitle, {
    staticClass: "danger--text"
  }, [_c(VIcon, {
    staticClass: "mr-2",
    attrs: {
      "color": "danger",
      "size": "16"
    }
  }, [_vm._v("fal fa-exclamation-triangle")]), _vm._v("\n        " + _vm._s(_vm.$i18n_t('accMgmt.tenant.bridges.errorList')) + "\n      ")], 1)], 1), _vm._l(_vm.errorBridges, function (instance, i) {
    return _c(VCol, {
      key: `bridge_${i}`,
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "4",
        "lg": "3",
        "xl": "2"
      }
    }, [_c(VCard, {
      staticClass: "mx-auto fav-dtwin-card grey-border",
      attrs: {
        "outlined": "",
        "href": `#/connectors/edit/${instance.tenantId}/${instance.id}?tab=statuslogs`,
        "target": "_blank"
      }
    }, [_c(VCardText, {
      staticClass: "text-truncate"
    }, [_c('span', {
      staticClass: "text-overline danger--text text-truncate",
      attrs: {
        "title": `${instance.tenantName} / ${instance.type.replace('bridge-', '')}`
      }
    }, [_vm._v("\n            " + _vm._s(instance.tenantName) + " / " + _vm._s(instance.type.replace('bridge-', '')) + "\n          ")]), _c('h4', {
      staticClass: "py-0 my-0"
    }, [_c('span', {
      class: `text-bold danger--text`
    }, [_vm._v(_vm._s(instance.name))])])])], 1)], 1);
  })], 2)], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };